import { Controller } from "@hotwired/stimulus";

// Handles server-side table filtering with debounced search and immediate filter changes.
// Used by AppTableHelper server-side mode with Ransack and Turbo Frames.
export default class extends Controller {
  connect() {
    this.timeout = null;
    this.debounceMs = 300;
  }

  // Immediate submit (for select/dropdown changes)
  submit() {
    clearTimeout(this.timeout);
    this.element.requestSubmit();
  }

  // Debounced submit (for search input - waits for user to stop typing)
  debounceSubmit() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.element.requestSubmit();
    }, this.debounceMs);
  }

  disconnect() {
    clearTimeout(this.timeout);
  }
}
